import { JSONPath } from "jsonpath-plus";
import { Modal } from "react-bootstrap";
import fr from './translations/fr.json'
import en from './translations/en.json'

export interface LoadingActionPendingModalProps {
    show: boolean
    close: () => void
    imageBaneerSrc: string
}

function t(key: string, currentLanguage = "fr") {
    return JSONPath({ path: key, json: currentLanguage === 'fr' ? fr : currentLanguage === 'en' ? en : fr });
}

export function LoadingActionPendingModal({
    show = false,
    close = () => { return },
    imageBaneerSrc = ""
}: LoadingActionPendingModalProps) {
    return <Modal
        dialogClassName="modal-LoadingAdvertising"
        show={show}
        onHide={close}
        backdrop="static"
        keyboard={false}
    // fullscreen={true}
    >
        <Modal.Body
            className="d-flex flex-column align-items-center justify-content-center"
        >
            <div>
                <div>
                    <img
                        src={imageBaneerSrc}
                        className="img-fluid"
                        alt="wait..."
                    />
                </div>
                <div className="text-center modal-LoadingAdvertising-title mt-5">
                    {t("loadingModal.title")}
                </div>
                <div className="text-center modal-LoadingAdvertising-desc">
                    {t("loadingModal.text")}
                </div>
                <div className="progress mt-5 mb-5 w-full">
                    <div className="progress-bar progress-bar-striped indeterminate"></div>
                </div>
            </div>
        </Modal.Body>
    </Modal>
}